export const BottomTopHalf = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.20605"
        y="0.5"
        width="18.2939"
        height="18.2939"
        rx="3.5"
        stroke="black"
      />
      <line x1="10.001" y1="9.79541" x2="10.001" y2="0.296851" stroke="black" />
      <line x1="20" y1="10.3105" x2="0.706053" y2="10.3105" stroke="black" />
    </svg>
  );
};
